import { render, staticRenderFns } from "./ActiveRemoteConnections.vue?vue&type=template&id=140a8f90"
import script from "./ActiveRemoteConnections.vue?vue&type=script&lang=js"
export * from "./ActiveRemoteConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports